import {
  reactive,
  ref,
} from 'vue';
import { defineStore } from 'pinia';
import { jwtDecode } from 'jwt-decode';
import { datadogRum } from '@datadog/browser-rum';
import * as env from '@/config';

export default defineStore('user', () => {
  const userInfo = reactive({
    accessToken: '',
    mid: '',
    fuel2token: '',
    scope: [],
  });

  const timeZone = ref('UTC');
  const timeZoneList = reactive([
    {
      type: 'UTC',
      offset: 0,
      text: '(UTC)',
    },
    // {
    //   type: 'KST',
    //   offset: -540,
    //   text: '(KST)',
    // },
  ]);

  const setUser = ({
    accessToken,
    fuel2token,
    mid,
  }) => {
    if (env.datadogApplicationId) {
      datadogRum.init({
        applicationId: env.datadogApplicationId,
        clientToken: env.datadogClientToken,
        site: 'datadoghq.com',
        service: env.datadogService,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        defaultPrivacyLevel: 'allow',
        sessionPersistence: 'local-storage',
        allowedTracingUrls: [
          'https://mc.api.i2message.io',
          'https://core.api.i2message.io',
        ],
      });
    }

    userInfo.accessToken = accessToken;
    userInfo.fuel2token = fuel2token;
    userInfo.mid = mid;

    try {
      const payload = jwtDecode(accessToken);

      userInfo.scope = payload.user_scope.split(',');

      // datadog
      if (env.datadogApplicationId) {
        datadogRum.onReady(() => {
          datadogRum.startSessionReplayRecording({ force: true });

          datadogRum.setUser({
            id: payload.account_id,
            organizationId: payload.organization_id,
            username: payload.username,
          });
        });
      }
    } catch (error) {
      //
    }
  };

  const timezoneOffset = new Date().getTimezoneOffset();
  const symbol = timezoneOffset < 0 ? '+' : '-';
  const hour = Math.floor(Math.abs(timezoneOffset) / 60).toString().padStart(2, '0');
  const minutes = (Math.abs(timezoneOffset) % 60).toString().padStart(2, '0');

  timeZoneList.push({
    type: 'locale',
    offset: timezoneOffset,
    text: `(UTC${symbol}${hour}:${minutes})`,
  });

  const localStorageTimeZone = localStorage.getItem('timeZone');

  if (!timeZoneList.some(({ type }) => {
    if (type === localStorageTimeZone) {
      timeZone.value = localStorageTimeZone;
      return true;
    }

    return false;
  })) {
    timeZone.value = timeZoneList[0].type;
    localStorage.setItem('timeZone', timeZone.value);
  }

  const nextTimeZone = () => {
    const i = timeZoneList.findIndex(({ type }) => type === timeZone.value);
    const index = (i + 1) % timeZoneList.length;

    timeZone.value = timeZoneList[index].type;
    localStorage.setItem('timeZone', timeZone.value);
  };

  return {
    userInfo,
    setUser,
    timeZone,
    timeZoneList,
    nextTimeZone,
  };
});
